import { Box, Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";

interface Props {
    xAxisData?: string[];
    yAxisData?: number[];
    title?: string;
}

const LeadsLineGraph = ({
    xAxisData = [],
    yAxisData = [],
    title = "Leads by day of week"
}: Props) => {
    // Calculate max value for y-axis with some padding
    const maxValue = yAxisData.length > 0 ? Math.max(...yAxisData) + 5 : 31;

    return (
        <Box sx={{
            width: "100%",
            border: "solid 1px #0000001F",
            display: "flex",
            flexDirection: "column",
            borderRadius: "24px",
            marginBottom: "50px",
            mt: "24px",
            overflow: "hidden"
        }}>
            <Box sx={{ padding: "32px 16px" }}>
                <Typography variant="body_small" gutterBottom sx={{ color: "#5D6E69" }}>
                    {title}
                </Typography>
            </Box>

            <Box sx={{
                width: "100%",
                height: "450px",
                display: "flex",
                alignItems: "stretch",
                justifyContent: "stretch",
                overflow: "hidden"
            }}>
                <LineChart
                    xAxis={[{
                        data: xAxisData,
                        scaleType: "point",
                    }]}
                    yAxis={[{
                        min: 0,
                        max: maxValue
                    }]}
                    series={[
                        {
                            data: yAxisData,
                            color: "#ff8c00",
                            curve: "monotoneX",
                            showMark: false,
                            area: true,
                            stack: "total"
                        },
                    ]}
                    height={450}
                    margin={{ left: 30, right: 30, top: 10, bottom: 50 }}
                    slotProps={{
                        legend: { hidden: true },
                    }}
                    sx={{
                        width: "100%",
                        maxWidth: "100%",
                        "& .MuiLineElement-root": {
                            strokeWidth: 3,
                        },
                        "& .MuiMarkElement-root": {
                            fill: "#ff8c00",
                            stroke: "#ff8c00",
                            strokeWidth: 2,
                            r: 5,
                        },
                        "& .MuiAreaElement-root": {
                            fill: "url(#orangeGradient)",
                        },
                        "& .MuiChartsAxis-tickLabel": {
                            fontSize: "0.875rem",
                            fill: "#666",
                        },
                        "& .MuiChartsAxis-line": {
                            stroke: "#e0e0e0",
                        },
                        "& .MuiChartsGrid-line": {
                            stroke: "#f0f0f0",
                            strokeDasharray: "none",
                        },
                    }}
                >
                    <defs>
                        <linearGradient id="orangeGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" stopColor="#ff8c00" stopOpacity={0.8} />
                            <stop offset="50%" stopColor="#ffb347" stopOpacity={0.4} />
                            <stop offset="100%" stopColor="#ffe4b5" stopOpacity={0.1} />
                        </linearGradient>
                    </defs>
                </LineChart>
            </Box>
        </Box>
    )
}

export default LeadsLineGraph;